import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/Card';
import Carousel from '../components/Carousel';
import { useI18n } from '../i18n/LanguageProvider';

const Services = () => {
  const { services, t } = useI18n();
  return (
    <section className="section">
      <div className="container">
        <h1>{t('servicesPage.title')}</h1>
        <p className="muted">{t('servicesPage.subtitle')}</p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1rem',
            marginTop: '1rem',
            alignItems: 'stretch'
          }}
        >
          {services.map(s => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              style={{ textDecoration: 'none', display: 'block', height: '100%' }}
            >
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>{/* добавлено */}
                <Carousel images={s.images} alt={s.title} />
                <div style={{ marginTop: 12 }}>
                  <strong>{s.title}</strong>
                  <p className="muted">{s.short}</p>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Services;
